export class TagTableRelation {
  static readonly Partner = "mlgenpartner";
  static readonly ProjectHead = "hmgenproject";
  static readonly Parts = "mxstrparts";
  static readonly Depot = "mmgendepot";
  static readonly PartnerReportRelation = "rmgenpartnerrep";
  static readonly PurchaseOrderHead = "hmgenpurchorder";
  static readonly FacDeliveryNoteHead = "hmfacdeliverynote";
  static readonly OrderHead = "hlstrcustorder";
  static readonly OperationSheetItem = "imfacsheetoper";
  static readonly GeniItem = "iminigeninvitem";
}